import { yupResolver } from '@hookform/resolvers/yup';
import { documentTypesKeys } from '@payments-checkout/shared/helpers/constants/document-person-type.const';
import { digitalWalletInformationSchema } from '@payments-checkout/shared/helpers/constants/validation-input';
import { Select } from '@stone-payments/jade';
import { useEffect } from 'react';
import { FormProvider, useForm, useWatch } from 'react-hook-form';
import { useIntl } from 'react-intl';
import { DocumentInput } from '../../components/documentInput/documentInput';

type GooglePayRequiredFieldsProps = {
  setIsDigitalWalletValid: (value: boolean) => void;
};

export const ClickToPayRequiredFields = ({
  setIsDigitalWalletValid,
}: GooglePayRequiredFieldsProps) => {
  const { formatMessage } = useIntl();

  const methods = useForm({
    mode: 'onBlur',
    resolver: yupResolver(digitalWalletInformationSchema),
    defaultValues: {
      documentType: 'cpf',
    },
  });
  const documentType = useWatch({
    control: methods.control,
    name: 'documentType',
    defaultValue: 'cpf',
  });

  useEffect(() => {
    setIsDigitalWalletValid(methods.formState.isValid);
    return () => setIsDigitalWalletValid(false);
  }, [methods.formState.isValid, setIsDigitalWalletValid]);

  return (
    <FormProvider {...methods}>
      <div
        className="flex gap-jade-200 flex-col w-full lg:flex-row md:flex-row"
        data-testid="google-pay-required-fields"
      >
        <Select
          label={formatMessage({ id: 'customerForm.document' }) + ' *'}
          required
          size="medium"
          options={documentTypesKeys.map((document, index) => ({
            key: `${document}-${index}`,
            value: documentTypesKeys[index],
            label: formatMessage({ id: `customerForm.${document}` }),
          }))}
          {...methods.register('documentType')}
        />
        <DocumentInput
          key={documentType}
          documentType={documentType}
          autoFocus
        />
      </div>
    </FormProvider>
  );
};
